export const taskTypeScopeOptionStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
};

export const taskTypeScopeOptionNameStyles = {
  flex: 1,
  minWidth: 0,
};
